import { bindActionCreators } from 'redux';
import { commonActionFromDALV2, getMe, updateAuthen } from '../../common/actions/CommonAction';
import { O2OCommonContainer } from '../../common/container/O2OContainer';
import { IState } from '../../redux/reducer/index';
import { userLogin, userLogin2ft } from './actions/LoginAction';
import LoginComponentV3 from './LoginComponentV3';

function mapStateToProps(rootState: IState) {
  return {
    user: rootState.user,
    companyName: 'Account',
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    login: bindActionCreators(userLogin, dispatch),
    updateAuthen: bindActionCreators(updateAuthen, dispatch),
    getMe: bindActionCreators(getMe, dispatch),
    userLogin2ft: bindActionCreators(userLogin2ft, dispatch),
    commonActionFromDALV2: bindActionCreators(commonActionFromDALV2, dispatch),
  };
}

export const LoginContainer = O2OCommonContainer(LoginComponentV3, mapStateToProps, mapDispatchToProps);
// LoginComponent
